import { useContext } from 'react'

import { MessageTimelineContext } from '../MessageTimelineContext'

export const useTimelineContext = () => {
    const context = useContext(MessageTimelineContext)
    if (!context) {
        throw new Error('useTimelineContext must be used within a MessageTimelineWrapper')
    }
    return context
}
